import { combineReducers } from 'redux';
import create from './lfpGame/create';
import infoWidget from './lfpGame/infoWidget';
import update from './lfpGame/update';

export default combineReducers({
    create,
    infoWidget,
    update
});



// WEBPACK FOOTER //
// ./src/reducers/app/onSite/lfpGame.js